const Loading = (props)=> {
    return ( <>

    <button className="btn btn-primary d-flex align-items-center" type="button" disabled>
  <span className="spinner-border spinner-border-sm mx-1" role="status" aria-hidden="true"></span>
   {props.children}
</button>
    
    </> );
}
 
export default Loading;